import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {GridModule} from '@progress/kendo-angular-grid';
import {DialogModule} from '@progress/kendo-angular-dialog';
import {ButtonsModule} from '@progress/kendo-angular-buttons';
import {
    RarsPublishDialogComponent
} from './components/rars-publish-dialog/rars-publish-dialog.component';

@NgModule({
    declarations: [RarsPublishDialogComponent],
    imports: [CommonModule, GridModule, DialogModule, ButtonsModule],
    exports: [RarsPublishDialogComponent]
})
export class RarsPublishModule {
}
